/**
 * OAuth Callback Server Module
 *
 * Provides HTTP server functionality for handling OAuth authorization callbacks
 */

export {
  createCallbackServer,
  OAuthCallbackServer,
  waitForOAuthCallback,
  type CallbackResult,
  type CallbackServerOptions,
} from './callback.js';

export {
  ERROR_TEMPLATE,
  renderErrorPage,
  renderSuccessPage,
  renderTemplate,
  SUCCESS_TEMPLATE,
} from './templates.js';
